import Vue from 'vue'
import App from './App.vue'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js